const suffixRegex = /-\d+$/; // ends with -digits

/**
 * @remarks Elastic indices behind an alias are created like `${name}-${timestamp}`. This removes the `-timestamps` bit.
 */
export const removeIndexSuffix = (name: string) => {
	return name.replace(suffixRegex, '');
};
